export default __webpack_public_path__ + "static/media/stripe_dark_crop.77957d15.png";